export const ModalTicketTableConfig = [
  {
    title: "티켓 ID",
    dataIndex: "id"
  },
  {
    title: "티켓명",
    dataIndex: "title"
  },
  {
    title: "선택",
    dataIndex: "",
    scopedSlots: {
      customRender: "choice"
    }
  }
];
